import {store} from '@bitstillery/common/app'
import {dayjs} from '@bitstillery/common/lib/utils'

import {$s} from '@/app'
import {cms_fragment_cache} from '@/cms/runtime/fragments'
import type {StatePortal} from '@/lib/state'

/** The popups the content frame can show, each keyed by the day it was last dismissed. */
type PopupKey = keyof StatePortal['popup']

/**
 * The fragment the content frame renders as a popup. Unlike the offer and promotion popups there is no
 * row behind it that could switch it off — publishing the fragment is what turns the popup on, and
 * unpublishing it is what takes it away.
 */
export const CMS_POPUP_FRAGMENT = 'cms-popup'

/**
 * Once a day, per visitor: a stored timestamp is the whole contract, and the dismissal has to be read
 * back before the popup is selected — without the check it is re-selected on the very next redraw and
 * closing it does nothing.
 */
export function popup_dismissed_today(key: PopupKey): boolean {
    return dayjs().isSame(dayjs($s.popup[key]), 'day')
}

/** Store today's dismissal, which is what keeps the popup closed for the rest of the day. */
export function dismiss_popup(key: PopupKey): void {
    $s.popup[key] = dayjs().toJSON()
    void store.save()
}

/** Whether the popup fragment is published and today's dismissal hasn't been stored yet. */
export function cms_popup_active(): boolean {
    return cms_fragment_cache.has(CMS_POPUP_FRAGMENT) && !popup_dismissed_today('fragment')
}

/**
 * Closing the popup, as a catalog binding. Authored JSX owns the `Dialog` that holds the close button
 * while the once-a-day contract lives out here, so this is the one dismissal a CMS view can reach.
 */
export function popup_dismiss(): void {
    dismiss_popup('fragment')
}
